import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import image1 from "assets/img/bg.jpg";
import image2 from "assets/img/bg2.jpg";
import image3 from "assets/img/bg3.jpg";

import styles from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.js";

const useStyles = makeStyles(styles);

export default function SectionCarousel() {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            {new Date() < new Date("2026-04-05") && (
              <div style={{
                backgroundColor: "#f44336",
                color: "#fff",
                padding: "15px 20px",
                borderRadius: "4px",
                textAlign: "center",
                marginBottom: "20px",
                fontSize: "16px"
              }}>
                <strong>Estimados Clientes,</strong> informamos que no dia <strong>4 de Abril de 2026 (Sábado)</strong> estaremos encerrados devido a época festiva. Agradecemos a vossa compreensão.
              </div>
            )}
            <h2 className={classes.title}>Instalações</h2>
            <h5 className={classes.description}>
            O CiViseu é um centro de inspecções com experiência na área das inspecções automóveis. O nosso objectivo é contribuir para o aumento da segurança rodoviária. 
            Somos um centro de categoria B: atribuição nova matricula e inspeções especiais e temos a maior capacidade inspectiva do distrito de Viseu. 
            </h5>
            <br></br>
            <br></br>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={10} className={classes.marginAuto}>
            <Card carousel>
              <Carousel {...settings}>
                <div>
                  <img src={image1} alt="First slide" className="slick-image" />
                  <div className="slick-caption"></div>
                </div>
                <div>
                  <img
                    src={image2}
                    alt="Second slide"
                    className="slick-image"
                  />
                  <div className="slick-caption"></div>
                </div>
                <div>
                  <img src={image3} alt="Third slide" className="slick-image" />
                  <div className="slick-caption"></div>
                </div>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
